import React from "react";
import { Link } from "gatsby";
import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone } from "lucide-react";
import { StaticImage } from "gatsby-plugin-image";

const Footer = () => {
  return (
    <footer className="bg-primary-50 text-primary-800 py-16 border-t border-primary-100 font-sans">
      <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-12">
        
        {/* Brand Column */}
        <div className="space-y-6">
          <span className="font-serif text-3xl tracking-widest text-primary-900 block">
            Dilshani Wettasinghe
          </span>

          <p className="text-sm leading-relaxed text-primary-900/80 font-serif italic">
            "Crafting edible masterpieces for your most unforgettable moments."
          </p>
          <div className="flex space-x-5 pt-2">
            <a href="https://www.instagram.com/dilshaniwettasinghe/" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:text-accent-500 transition-colors"><Instagram size={24} /></a>
            <a href="https://www.facebook.com/dilshani.wettasinghe.2025/" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:text-accent-500 transition-colors"><Facebook size={24} /></a>
            <a href="https://www.linkedin.com/in/dilshani-wettasinghe-123811215/?originalSubdomain=lk" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:text-accent-500 transition-colors"><Linkedin size={24} /></a>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-primary-900 font-serif text-lg tracking-widest uppercase mb-6">Explore</h3>
          <ul className="space-y-4 text-sm tracking-wide">
            <li><Link to="/" className="hover:text-accent-500 transition-colors">Home</Link></li>
            <li><Link to="/gallery" className="hover:text-accent-500 transition-colors">Cake Gallery</Link></li>
            <li><Link to="/certifications" className="hover:text-accent-500 transition-colors">Certifications</Link></li>
            <li><Link to="/#about" className="hover:text-accent-500 transition-colors">About Dilshani</Link></li>
            <li><Link to="/#contact" className="hover:text-accent-500 transition-colors">Contact</Link></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="text-primary-900 font-serif text-lg tracking-widest uppercase mb-6">Dilshani Wettasinghe</h3>
          <ul className="space-y-4 text-sm mb-8">
            <li className="flex items-start space-x-4">
              <MapPin size={20} className="text-accent-500 mt-1 shrink-0" />
              <span className="leading-relaxed">Colombo<br />Sri Lanka</span>
            </li>
            <li className="flex items-center space-x-4">
              <Phone size={20} className="text-accent-500 shrink-0" />
              <a href="tel:+94769678787" className="hover:text-accent-500 transition-colors">076 9 678 787</a>
            </li>
            <li className="flex items-center space-x-4">
              <Mail size={20} className="text-accent-500 shrink-0" />
              <a href="mailto:dilshaniwettasinghe@gmail.com" className="hover:text-accent-500 transition-colors">dilshaniwettasinghe@gmail.com</a>
            </li>
          </ul>

          <h3 className="text-primary-900 font-serif text-lg tracking-widest uppercase mb-6 pt-4 border-t border-primary-200/50">Cake & Sugar Craft Academy</h3>
          <ul className="space-y-4 text-sm">
            <li className="flex items-center space-x-4">
              <Phone size={20} className="text-accent-500 shrink-0" />
              <a href="tel:+94775559953" className="hover:text-accent-500 transition-colors">077 5 559 953</a>
            </li>
            <li className="flex items-center space-x-4">
              <Mail size={20} className="text-accent-500 shrink-0" />
              <a href="mailto:Cakeandsugarcraftacademy@gmail.com" className="hover:text-accent-500 transition-colors break-all">Cakeandsugarcraftacademy@gmail.com</a>
            </li>
            <li className="flex items-center space-x-5 pt-2">
              <a href="https://www.facebook.com/cakeandsugarcraft/" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:text-accent-500 transition-colors"><Facebook size={20} /></a>
              <a href="https://www.instagram.com/cakeandsugarcraft.sl" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:text-accent-500 transition-colors"><Instagram size={20} /></a>
            </li>
          </ul>
        </div>

      </div>
      
      <div className="container mx-auto px-6 mt-16 pt-8 border-t border-primary-100/50 text-center text-xs tracking-widest uppercase text-primary-800/60">
        &copy; {new Date().getFullYear()} Dilshani Wettasinghe. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
